// AUTH
export const AUTH_SIGN_IN = "AUTH_SIGN_IN";
export const AUTH_SIGN_OUT = "AUTH_SIGN_OUT";

// CURRENCY
export const CREATE_CURRENCY = "CREATE_CURRENCY";

// EXPENSES
export const CREATE_EXPENSE = "CREATE_EXPENSE";
export const FETCH_EXPENSES = "FETCH_EXPENSES";
export const DELETE_EXPENSE = "DELETE_EXPENSE";
export const UPDATE_EXPENSE = "UPDATE_EXPENSE";
export const CLEAR_EXPENSES = "CLEAR_EXPENSES";

// INVENTORY
export const TEMPORARY_INVENTORY = "TEMPORARY_INVENTORY";
export const CLEAR_TEMPORARY_INVENTORY = "CLEAR_TEMPORARY_INVENTORY";
export const CREATE_INVENTORY = "CREATE_INVENTORY";
export const FETCH_INVENTORYS = "FETCH_INVENTORYS";
export const DELETE_INVENTORY = "DELETE_INVENTORY";
export const UPDATE_INVENTORY = "UPDATE_INVENTORY";
export const CLEAR_INVENTORYS = "CLEAR_INVENTORYS";

// NOTIFICATIONS
export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";

// PRODUCTS
export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";

// SALES
export const FETCH_SALES_LIST = "FETCH_SALES_LIST";
export const CREATE_SALE = "CREATE_SALE";
export const DELETE_SALE = "DELETE_SALE";
export const UPDATE_SALE = "UPDATE_SALE";
export const CLEAR_SALE = "CLEAR_SALE";

// SEARCH
export const FETCH_SEARCH_LIST = "FETCH_SEARCH_LIST";
export const CREATE_SEARCH = "CREATE_SEARCH";
export const CLEAR_SEARCH = "CLEAR_SEARCH";
export const ACTIVE_PAGE = "ACTIVE_PAGE";

// SEARCH
export const FETCH_SELLERS_LIST = "FETCH_SELLERS_LIST";
export const CREATE_SELLER = "CREATE_SELLER";
export const CLEAR_SELLER = "CLEAR_SELLER";
export const DELETE_SELLER = "DELETE_SELLER";
export const UPDATE_SELLER = "UPDATE_SELLER";

// USER
export const CREATE_USER = "CREATE_USER";
export const FETCH_USER = "FETCH_USER";
export const CLEAR_USER_DATA = "CLEAR_USER_DATA";